export enum RelevanceRatingId {
  relevant = 'RELEVANT',
  notRelevant = 'NOT_RELEVANT',
  toClarify = 'TO_CLARIFY',
  toMonitor = 'TO_MONITOR',
  notRated = 'NOT_RATED'
}
